import Loadable from 'react-loadable'
import { filter, toLower } from 'lodash'
import PageLoading from '@components/PageLoading'
import {
  BettorFindIco,
  ClubPortalIco,
  BettingRulesIco,
  GiftboxIco,
  MyBankIco,
  PickIco,
  MissionIco,
  GuideIco,
  CouponIco,
  InquiryIco,
  EventIco,
  FriendsInvitationIco,
  NoticeIco,
} from '@shared/Icon/MenuIcon'
import BettingHistoryGradientIco from '@assets/images/icon/menu_icon/betting-history-gradient-ico.png'
import MatchupResultGradientIco from '@assets/images/icon/menu_icon/matchup-result-gradient-ico.png'
import MessageGradientIco from '@assets/images/icon/menu_icon/message-gradient-ico.png'
import ShopGradientIco from '@assets/images/icon/menu_icon/shop-gradient-ico.png'
// import { LogoIco } from '@shared/Icon/LogoIcon'
import globalStore from '@store/globalStore'
import { SIDE_MENU } from '@constants/index'

const loadComponent = (loader: () => Promise<any>) => Loadable({ loader, loading: PageLoading })

export const asynchronousComponents = {
  Users: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Users')),

  Home: loadComponent(() => import(/* webpackChunkName: "socket-debugger" */ '@views/Home')),
  MyBank: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/MyBank')),
  BettingHistory: loadComponent(() => import(/* webpackChunkName: "socket-debugger" */ '@views/BettingHistory')),
  Club: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Club')),
  MatchupResult: loadComponent(() => import(/* webpackChunkName: "socket-debugger" */ '@views/MatchupResult')),
  Matchup: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Matchup')),
  MatchupDetail: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Matchup/MatchUpDetail')),
  MatchupFilter: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Matchup/MatchUpFilter')),
  ItemShop: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/ItemShop')),
  Pick: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Pick')),
  Join: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Join')),
  Agree: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Join/Agree')),
  IdentityVerification: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Join/IdentityVerification')),
  UserInfo: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Join/UserInfo')),
  PreviousUserInfo: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Join/PreviousUserInfo')),
  Quiz: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Join/Quiz')),
  JoinEnd: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Join/JoinEnd')),
  // ScashCharge: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/ScashCharge')),
  // ScashChargeSuccess: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/ScashCharge/Success')),
  // ScashChargeFailure: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/ScashCharge/Failure')),
  MyPage: loadComponent(() => import('@views/MyPage')),
  ServerCheck: loadComponent(() => import('@views/ServerCheck')),
  BettorFind: loadComponent(() => import(/* webpackChunkName: "socket-debugger" */ '@views/BettorFind')),
  Mission: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Mission')),
  Guide: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Guide')),
  TelegramGuide: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/TelegramGuide')),
  CouponInput: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Coupon/CouponInput')),
  CouponCheck: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Coupon/CouponCheck')),
  VocPage: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/VocPage')),
  BettingRules: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/BettingRules')),
  EventPage: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/EventPage')),
  NaverAuthResultPage: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/NaverAuthResult')),
  AdvCasinoPage: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/AdvCasino')),
  Notice: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Notice')),
  FriendsInvitation: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/FriendsInvitation')),
  AdvNewsPage: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Home/AdvNews/AdvNewsList')),
  TodayPickDetailPage: loadComponent(() => import(/* webpackChunkName: "users" */ 'containers/views/Home/TodayPick/CompanyPickDetail')),
  UserPickPage: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Home/UserPick/UserPickPage')),
  TodayPickManagerList: loadComponent(() => import(/* webpackChunkName: "users" */ '@views/Home/TodayPick/CompanyPickManagerList')),
}

// all routers key
export type AsynchronousComponentKeys = keyof typeof asynchronousComponents

export interface RouteMenu {
  id: string
  exact: boolean
  pid?: number
  /** 로그인이 필요한 메뉴 인가? */
  signedin?: boolean
  path?: string
  name?: string
  icon?: () => JSX.Element
  iconImg?: string
  component?: AsynchronousComponentKeys
  namespace?: string // models's namespace to set popup page
  locale?: string
  invisible?: boolean
  chattingVisible?: boolean // 메뉴 클릭시 하다 채팅창이 보일지 말지 여부
}

export interface MenuInTree extends RouteMenu {
  children?: MenuInTree[]
}

const menus: RouteMenu[] = [
  {
    id: '1',
    exact: true,
    signedin: true,
    path: '/betting-history',
    name: 'Betting History',
    namespace: SIDE_MENU.BETTING_HISTORY,
    iconImg: BettingHistoryGradientIco,
    component: 'BettingHistory',
    locale: '베팅내역',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '2',
    exact: true,
    signedin: true,
    path: '/matchupResult',
    name: 'Matchup Result',
    namespace: SIDE_MENU.MATCHUP_RESULT,
    iconImg: MatchupResultGradientIco,
    component: 'MatchupResult',
    locale: 'SCORE',
    invisible: false,
    chattingVisible: false,
  },

  {
    id: '3',
    exact: true,
    signedin: false,
    iconImg: MessageGradientIco,
    namespace: SIDE_MENU.MESSAGE,
    locale: '메시지함',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '4',
    exact: true,
    signedin: false,
    path: '/itemshop',
    name: 'Itemshop',
    namespace: SIDE_MENU.ITEM_SHOP,
    iconImg: ShopGradientIco,
    component: 'ItemShop',
    locale: '상점',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '5',
    exact: true,
    signedin: true,
    path: '/betting-rules',
    name: 'bettingRules',
    namespace: SIDE_MENU.BETTING_RULES,
    icon: BettingRulesIco,
    component: 'BettingRules',
    locale: '베팅규정',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '6',
    exact: true,
    signedin: false,
    path: '/club',
    name: 'Club',
    namespace: SIDE_MENU.CLUB,
    icon: ClubPortalIco,
    component: 'Club',
    locale: '클럽이동',
    invisible: false,
    chattingVisible: true,
  },
  {
    id: '7',
    exact: true,
    signedin: true,
    path: '/my-bank',
    name: 'My Bank',
    namespace: SIDE_MENU.MY_BANK,
    icon: MyBankIco,
    component: 'MyBank',
    locale: '마이뱅크',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '8',
    exact: true,
    signedin: true,
    path: '/pick',
    name: 'Pick',
    namespace: SIDE_MENU.PICK,
    icon: PickIco,
    component: 'Pick',
    locale: '픽거래소',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '9',
    exact: true,
    signedin: false,
    name: 'Inquiry',
    namespace: SIDE_MENU.INQUIRY,
    icon: InquiryIco,
    locale: '1:1 문의',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '10',
    exact: true,
    signedin: true,
    path: '/bettor-find',
    name: 'BettorFind',
    namespace: SIDE_MENU.BETTOR_FIND,
    icon: BettorFindIco,
    component: 'BettorFind',
    locale: '베터찾기',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '11',
    exact: true,
    signedin: false,
    path: '/mission',
    name: 'Mission',
    namespace: SIDE_MENU.MISSION,
    icon: MissionIco,
    component: 'Mission',
    locale: '미션',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '12',
    exact: true,
    signedin: true,
    path: '/guide',
    name: 'Guide',
    namespace: SIDE_MENU.GUIDE,
    icon: GuideIco,
    component: 'Guide',
    locale: '승부사팁',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '13',
    exact: true,
    signedin: true,
    path: '/coupon-input',
    name: 'Coupon',
    namespace: SIDE_MENU.COUPON,
    icon: CouponIco,
    component: 'CouponInput',
    locale: '쿠폰입력',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '15',
    exact: true,
    signedin: true,
    name: 'Event',
    namespace: SIDE_MENU.ATTENDANCE,
    icon: EventIco,
    locale: '출석 이벤트',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '16',
    exact: true,
    signedin: true,
    path: '/notice',
    name: 'Notice',
    namespace: SIDE_MENU.NOTICE,
    icon: NoticeIco,
    component: 'Notice',
    locale: '공지사항',
    invisible: false,
    chattingVisible: false,
  },
  {
    id: '17',
    exact: true,
    signedin: true,
    path: '/friends-invitation',
    name: 'FriendsInvitation',
    namespace: SIDE_MENU.FRIENDS_INVITATION,
    icon: FriendsInvitationIco,
    component: 'FriendsInvitation',
    locale: '친구초대',
    invisible: false,
    chattingVisible: false,
  },
  // {
  //   id: 'divider',
  //   exact: true,
  //   signedin: true,
  //   path: '/',
  //   name: '',
  //   icon: ,
  // },

  // {
  //   id: '3',
  //   exact: true,
  //   signedin: false,
  //   path: '/home',
  //   name: 'Home',
  //   icon: ,
  //   component: 'Home',
  //   locale: '홈',
  // },


  // 이 라우팅은 사이더 메뉴에서 보여주지 않도록 설정된다.
  {
    id: '100',
    exact: true,
    signedin: false,
    path: '/home',
    name: 'Home',
    namespace: 'home',
    component: 'Home',
    locale: '홈',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '101',
    exact: true,
    signedin: false,
    path: '/',
    name: '',
    namespace: '',
    component: 'Matchup',
    locale: '홈',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '102',
    exact: true,
    signedin: false,
    path: '/join',
    name: '',
    namespace: 'join',
    component: 'Join',
    locale: '회원가입',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '103',
    exact: true,
    signedin: false,
    path: '/matchup/:tabName/:id',
    name: '',
    namespace: 'matchup',
    component: 'Matchup',
    locale: '클럽',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '104',
    exact: true,
    signedin: false,
    path: '/coupon-check',
    name: '',
    namespace: 'coupon-check',
    component: 'CouponCheck',
    locale: '쿠폰확인',
    invisible: true,
    chattingVisible: false,
  },
  // {
  //   id: '104',
  //   exact: true,
  //   signedin: false,
  //   path: '/scash',
  //   name: '',
  //   component: 'ScashCharge',
  //   locale: 'S캐시 충전',
  //   invisible: true,
  //   chattingVisible: false,
  // },
  {
    id: '105',
    exact: true,
    signedin: true,
    path: '/my-info',
    name: '',
    namespace: 'my-info',
    component: 'MyPage',
    locale: '마이페이지',
    invisible: true,
    chattingVisible: false,
  },
  // {
  //   id: '105',
  //   exact: true,
  //   signedin: false,
  //   path: '/scash/success',
  //   name: '',
  //   component: 'ScashChargeSuccess',
  //   locale: 'S캐시 충전',
  //   invisible: true,
  //   chattingVisible: false,
  // },
  // {
  //   id: '106',
  //   exact: true,
  //   signedin: false,
  //   path: '/scash/failure',
  //   name: '',
  //   component: 'ScashChargeFailure',
  //   locale: 'S캐시 충전',
  //   invisible: true,
  //   chattingVisible: false,
  // },
  {
    id: '107',
    exact: true,
    signedin: false,
    path: '/matchupDetail/:clubId/:producerIdStr/:matchIdStr',
    name: '',
    namespace: 'matchupDetail',
    component: 'MatchupDetail',
    locale: '상세 BET',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '108',
    exact: true,
    signedin: false,
    path: '/serverCheck',
    name: '',
    component: 'ServerCheck',
    locale: '서버점검',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '109',
    exact: true,
    signedin: false,
    path: '/telegramGuide',
    name: '',
    component: 'TelegramGuide',
    locale: '텔레그램 알림',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '110',
    exact: true,
    signedin: false,
    path: '/voc-page',
    name: '',
    component: 'VocPage',
    locale: 'VOC',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '111',
    exact: true,
    signedin: false,
    path: '/m-eventPage01',
    name: '',
    component: 'EventPage',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '112',
    exact: true,
    signedin: false,
    path: '/m-eventPage02',
    name: '',
    component: 'EventPage',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '113',
    exact: true,
    signedin: false,
    path: '/agree',
    name: '',
    namespace: 'Agree',
    component: 'Agree',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '114',
    exact: true,
    signedin: false,
    path: '/identityVerification',
    name: '',
    namespace: 'IdentityVerification',
    component: 'IdentityVerification',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '115',
    exact: true,
    signedin: false,
    path: '/userinfo',
    name: '',
    namespace: 'UserInfo',
    component: 'UserInfo',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '116',
    exact: true,
    signedin: false,
    path: '/previousUserinfo',
    name: '',
    namespace: 'PreviousUserInfo',
    component: 'PreviousUserInfo',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '126',
    exact: true,
    signedin: false,
    path: '/quiz',
    name: '',
    namespace: 'Quiz',
    component: 'Quiz',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '117',
    exact: true,
    signedin: false,
    path: '/end',
    name: '',
    namespace: 'JoinEnd',
    component: 'JoinEnd',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '118',
    exact: true,
    signedin: false,
    path: '/naverAuthResult',
    name: '',
    component: 'NaverAuthResultPage',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '119',
    exact: true,
    signedin: true,
    name: 'GiftBox',
    icon: GiftboxIco,
    namespace: SIDE_MENU.GIFTBOX,
    locale: '선물상자',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '120',
    exact: true,
    signedin: false,
    path: '/adv-casino',
    name: '',
    component: 'AdvCasinoPage',
    locale: '승부사카지노',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '121',
    exact: true,
    signedin: false,
    path: '/today-pick-detail',
    name: '',
    component: 'TodayPickDetailPage',
    locale: '프리미엄 분석가',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '122',
    exact: true,
    signedin: false,
    path: '/adv-news',
    name: '',
    component: 'AdvNewsPage',
    locale: '승부사소식',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '123',
    exact: true,
    signedin: true,
    path: '/matchup-filter',
    name: '',
    component: 'MatchupFilter',
    locale: '리그필터',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '124',
    exact: true,
    signedin: true,
    path: '/user-pick',
    name: '',
    component: 'UserPickPage',
    locale: '나도 승부사',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '301',
    exact: true,
    signedin: false,
    path: '/main',
    name: '',
    namespace: '',
    component: 'Matchup',
    locale: '홈',
    invisible: true,
    chattingVisible: false,
  },
  {
    id: '125',
    exact: true,
    signedin: false,
    path: '/today-pick-manager-list',
    name: '',
    component: 'TodayPickManagerList',
    locale: '프리미엄 분석가 목록',
    invisible: true,
    chattingVisible: false,
  },
]

export function filterMenus(
  isSignedIn: boolean,
  isSpecificClubMember: boolean,
  missionEnabled: boolean,
  isTestAccount: boolean,
  isFriendInvitationEnabled: boolean,
  isPossibleInvitor: boolean,
) {
  const excludeMenuNames = []

  const availablekeys = globalStore.getMenuAvailableList()
  let availableFiltered = menus
  if (availablekeys) {
    availableFiltered = filter(menus, (el: RouteMenu) => {
      return availablekeys.indexOf(el.namespace) >= 0 || el.invisible === true
    })
  }

  availableFiltered = availableFiltered.map((menu: RouteMenu) => {
    if (menu.namespace !== SIDE_MENU.MATCHUP_RESULT) {
      return menu
    }

    return {
      ...menu,
      locale: globalStore.getScorePageTitle(),
    }
  })

  if (isSpecificClubMember) {
    // excludeMenuNames.push('club')
    excludeMenuNames.push('pick')
    if (availableFiltered[8].id === '9') {
      availableFiltered[8].locale = '클럽정보'
    }
  }

  if (!missionEnabled) {
    excludeMenuNames.push('mission')
  }

  if (isTestAccount) {
    excludeMenuNames.push('club')
    excludeMenuNames.push('itemshop')
  }

  if (!isFriendInvitationEnabled || !isPossibleInvitor) {
    excludeMenuNames.push('friendsinvitation')
  }

  const filtered = filter(availableFiltered, (el: RouteMenu) => {
    if (excludeMenuNames.length > 0) {
      const name = toLower(el.name)
      return !excludeMenuNames.includes(name)
    }
    return el.id.length > 0
  })
  if (isSignedIn) {
    return filtered
  }
  // eslint-disable-next-line arrow-body-style
  return filter(filtered, (el: RouteMenu) => {
    return el.signedin === false
  })
}

export default menus
